import React, { useContext, useState } from "react"

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap"

import { AuthContext } from "@meddbriefer/mdb-auth"
// import { usePrefs } from "../../contexts/PreferencesContext"
import UserIcon from "./UserIcon"

export default function UserDropDown({show}) {
    const { userName, signOutUser } = useContext(AuthContext)
    // const {displayPrefsForm} = usePrefs()
    const [showUserMenu, setShowUserMenu] = useState(false)
    const toggleUserMenu = () => setShowUserMenu(!showUserMenu)

    if (!show) {
        return (<span></span>)
    }

    return (
        <Dropdown nav inNavbar isOpen={showUserMenu} direction="down" toggle={toggleUserMenu}>
            <DropdownToggle nav caret >
                <UserIcon dark="true" />
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem disabled>{userName}</DropdownItem>
                <DropdownItem divider />
                {/* <DropdownItem onClick={displayPrefsForm}>Preferences</DropdownItem>
                <DropdownItem divider /> */}
                <DropdownItem onClick={signOutUser}>Sign Out</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}
